import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getMarketPriceConfig,
  MarketPriceConfigResponse,
} from '../../../api/v1/market'
import { RootState } from '../../index'

export const getMarketPriceConfigAction = createAsyncThunk<
  MarketPriceConfigResponse,
  undefined,
  { state: RootState }
>('market/getMarketPriceConfigAction', async (_, { getState }) => {
  const state = getState()

  if (state.market.marketPriceConfig) {
    return state.market.marketPriceConfig
  }

  const { data } = await getMarketPriceConfig()
  return data
})
